import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { CreateProfileHomePageComponent } from './pages/create-profile-home-page/create-profile-home-page.component';
import { RegistrationConfirmationPageComponent } from './pages/registration-confirmation-page/registration-confirmation-page.component';
import { WatchlistPageComponent } from './pages/watchlist-page/watchlist-page.component';
import { UserProfilePageComponent } from './pages/user-profile-page/user-profile-page.component';
import { UserBidsComponent } from './components/user-bids/user-bids.component';
import { UserProfileComponent } from './components/user-profile/user-profile.component';
import { UserAddressesComponent } from './components/user-addresses/user-addresses.component';
import { UserAddressesFormComponent } from './components/user-addresses-form/user-addresses-form.component';
import { UserInvoicesComponent } from './components/user-invoices/user-invoices.component';
import { UserAppointmentsComponent } from './components/user-appointments/user-appointments.component';
import { UserInformationComponent } from './components/user-information/user-information.component';
import { ViewInvoicePageComponent } from './pages/view-invoice-page/view-invoice-page.component';
import { UserPaymentInformationComponent } from './components/user-payment-information/user-payment-information.component';
import { AddPaymentInformationFormComponent } from './components/add-payment-information-form/add-payment-information-form.component';
import { UserNotificationsRemindersComponent } from './components/user-notifications-reminders/user-notifications-reminders.component';
import { InvoicePaymentsComponent } from './components/invoice-payments/invoice-payments.component';
import { UserMessagesComponent } from './components/user-messages/user-messages.component';
import { AuthGuard } from 'src/app/auth.guard';
import { AuthGuard as ProfileAuthGuard } from './auth.guard';
import { UserPurchaseOffersComponent } from './components/user-purchase-offers/user-purchase-offers.component';
import { UserNotificationsComponent } from './components/user-notifications/user-notifications.component';
import { UserNewsletterComponent } from './components/user-newsletter/user-newsletter.component';
import { uuidParamsMatchGuard } from '../../shared/guards/uuid-params-match.guard';

const routes: Routes = [
    { path: '', redirectTo: 'my-profile', pathMatch: 'full' },
    {
        path: 'create-profile',
        component: CreateProfileHomePageComponent,
        canActivate: [ProfileAuthGuard],
    },
    {
        path: 'registration-confirmation',
        component: RegistrationConfirmationPageComponent,
    },
    {
        path: 'watchlist',
        component: WatchlistPageComponent,
        canActivate: [ProfileAuthGuard, AuthGuard],
    },
    {
        path: 'my-profile',
        component: UserProfilePageComponent,
        // UserProfilePageComponent itself renders the account nav
        // sidebar — restricted chrome — so it needs the blocking guard too,
        // not just its children.
        canActivate: [ProfileAuthGuard, AuthGuard],
        children: [
            { path: '', redirectTo: 'profile', pathMatch: 'full' },
            {
                path: 'profile',
                component: UserProfileComponent,
                canActivate: [ProfileAuthGuard],
            },
            {
                path: 'my-bidding',
                component: UserBidsComponent,
                canActivate: [ProfileAuthGuard],
            },
            {
                path: 'my-addresses',
                component: UserAddressesComponent,
                canActivate: [ProfileAuthGuard],
            },
            {
                path: 'user-addresses',
                component: UserAddressesFormComponent,
                canActivate: [ProfileAuthGuard],
            },
            {
                path: 'user-addresses/:addressId',
                component: UserAddressesFormComponent,
                canActivate: [ProfileAuthGuard],
                canMatch: [uuidParamsMatchGuard],
            },
            {
                path: 'my-appointments',
                component: UserAppointmentsComponent,
                canActivate: [ProfileAuthGuard],
            },
            {
                path: 'my-invoices',
                component: UserInvoicesComponent,
                canActivate: [ProfileAuthGuard],
            },
            {
                path: 'user-information',
                component: UserInformationComponent,
                canActivate: [ProfileAuthGuard],
            },
            {
                path: 'view-invoice/:id',
                component: ViewInvoicePageComponent,
                canActivate: [ProfileAuthGuard],
                canMatch: [uuidParamsMatchGuard],
                title: 'Invoice Details',
            },
            {
                path: 'payment-information',
                component: UserPaymentInformationComponent,
                canActivate: [ProfileAuthGuard],
            },
            {
                path: 'add-payment-information',
                component: AddPaymentInformationFormComponent,
                canActivate: [ProfileAuthGuard],
            },
            {
                path: 'my-notifications-reminders',
                component: UserNotificationsRemindersComponent,
                canActivate: [ProfileAuthGuard],
            },
            {
                path: 'invoice-payments',
                component: InvoicePaymentsComponent,
                canActivate: [ProfileAuthGuard],
            },
            {
                path: 'messages',
                component: UserMessagesComponent,
                canActivate: [ProfileAuthGuard],
            },
            {
                path: 'my-offers',
                component: UserPurchaseOffersComponent,
                canActivate: [ProfileAuthGuard],
            },
            {
                path: 'notifications',
                component: UserNotificationsComponent,
                canActivate: [ProfileAuthGuard],
            },
            {
                path: 'newsletter',
                component: UserNewsletterComponent,
                canActivate: [ProfileAuthGuard],
            },
        ],
    },
    // Catch invalid paths under /profiles. The root '**' wildcard can't be
    // reached across the lazy-load boundary, so redirect them to the 404 page.
    { path: '**', redirectTo: '/404' },
];

@NgModule({
    declarations: [],
    imports: [CommonModule, RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class ProfilesRoutingModule {}
